
            //------------------------------------------------------------------------------
            // <auto-generated>
            //     This code was generated from a template.
            //
            //     Manual changes to this file may cause unexpected behavior in your application.
            //     Manual changes to this file will be overwritten if the code is regenerated.
            // </auto-generated>
            //------------------------------------------------------------------------------
        
	export enum Localization {
		 AcceptTheCrop = 'acceptTheCrop',
		 Account = 'account',
		 AccountAlreadyConfirmed = 'accountAlreadyConfirmed',
		 AccountNotConfirmed = 'accountNotConfirmed',
		 Add = 'add',
		 AdditionalNotes = 'additionalNotes',
		 Address = 'address',
		 AnnouncementNotFound = 'announcementNotFound',
		 Announcements = 'announcements',
		 ApplicationName = 'applicationName',
		 Back = 'back',
		 BadPasswordLength = 'badPasswordLength',
		 Bathroom = 'bathroom',
		 Bedroom = 'bedroom',
		 BuildingInside = 'buildingInside',
		 BuildingOutside = 'buildingOutside',
		 By = 'by',
		 Cancel = 'cancel',
		 Ceiling = 'ceiling',
		 Chat = 'chat',
		 Check = 'check',
		 Close = 'close',
		 Company = 'company',
		 Confirm = 'confirm',
		 ConfirmPassword = 'confirmPassword',
		 CreateIssueNotificationErrorMessage = 'createIssueNotificationErrorMessage',
		 CropAllImagesAutomatically = 'cropAllImagesAutomatically',
		 CropImagesBeforeUpload = 'cropImagesBeforeUpload',
		 Dashboard = 'dashboard',
		 Date = 'date',
		 DateOfBirth = 'dateOfBirth',
		 Day = 'day',
		 Delete = 'delete',
		 Description = 'description',
		 Details = 'details',
		 Discard = 'discard',
		 Documents = 'documents',
		 Door = 'door',
		 Download = 'download',
		 Edit = 'edit',
		 Email = 'email',
		 EmptyAnnouncementsListMessage = 'emptyAnnouncementsListMessage',
		 EmptyChatMessage = 'emptyChatMessage',
		 EmptyDataMessage = 'emptyDataMessage',
		 EmptyDocumentsListMessage = 'emptyDocumentsListMessage',
		 ErrorHeader = 'errorHeader',
		 ErrorMessage = 'errorMessage',
		 ErrorSubheader = 'errorSubheader',
		 Faucet = 'faucet',
		 Filter = 'filter',
		 Filters = 'filters',
		 Floor = 'floor',
		 FlushFillsVerySlowlyAfterFlushing = 'flushFillsVerySlowlyAfterFlushing',
		 ForgotPassword = 'forgotPassword',
		 Gender = 'gender',
		 GoToLoginPage = 'goToLoginPage',
		 HiWhatWouldYouLikeToDo = 'hiWhatWouldYouLikeToDo',
		 Hour = 'hour',
		 IdCardNumber = 'idCardNumber',
		 In = 'in',
		 IncorrectConfirmationCode = 'incorrectConfirmationCode',
		 InvalidEmail = 'invalidEmail',
		 InWhichRoomIsTheProblem = 'inWhichRoomIsTheProblem',
		 Issue = 'issue',
		 IssueCreationSuccessMessage1 = 'issueCreationSuccessMessage1',
		 IssueCreationSuccessMessage2 = 'issueCreationSuccessMessage2',
		 IssueNotificationStatus_Handled = 'issueNotificationStatus_Handled',
		 IssueNotificationStatus_Open = 'issueNotificationStatus_Open',
		 IssueNotificationStatus_Processing = 'issueNotificationStatus_Processing',
		 IssueNotificationStatus_WithoutConsequence = 'issueNotificationStatus_WithoutConsequence',
		 Issues = 'issues',
		 IssueStatus = 'issueStatus',
		 IssueSubmitted = 'issueSubmitted',
		 Kitchen = 'kitchen',
		 Language = 'language',
		 Lang_de = 'lang_de',
		 Lang_en = 'lang_en',
		 Lang_es = 'lang_es',
		 Lang_fr = 'lang_fr',
		 Lang_it = 'lang_it',
		 Lang_nl = 'lang_nl',
		 Lang_nl_BE = 'lang_nl_BE',
		 LivingRoom = 'livingRoom',
		 Location = 'location',
		 Login = 'login',
		 Logout = 'logout',
		 MailFooter = 'mailFooter',
		 Media = 'media',
		 Message = 'message',
		 Minute = 'minute',
		 Month = 'month',
		 MyUnit = 'myUnit',
		 NewIssueNotificationAdditionalNotesPlaceholder = 'newIssueNotificationAdditionalNotesPlaceholder',
		 NewMessage = 'newMessage',
		 No = 'no',
		 NoBuildingsMessage = 'noBuildingsMessage',
		 NoSpecificRoom = 'noSpecificRoom',
		 NotFlushingProperly = 'notFlushingProperly',
		 Notifications = 'notifications',
		 Open = 'open',
		 Other = 'other',
		 Password = 'password',
		 PasswordsDoNotMatch = 'passwordsDoNotMatch',
		 PasswordSetError = 'passwordSetError',
		 PasswordSetSuccess = 'passwordSetSuccess',
		 Phone = 'phone',
		 Photos = 'photos',
		 PhotoUploadErrorMessage = 'photoUploadErrorMessage',
		 Preferences = 'preferences',
		 Preview = 'preview',
		 Reply = 'reply',
		 ReportAProblem = 'reportAProblem',
		 ReportANewProblemInTheBuilding = 'reportANewProblemInTheBuilding',
		 ReportedBy = 'reportedBy',
		 ReportedOn = 'reportedOn',
		 RequestErrorMessage = 'requestErrorMessage',
		 Required = 'required',
		 Reset = 'reset',
		 ResetPassword = 'resetPassword',
		 ResetPasswordSuccess = 'resetPasswordSuccess',
		 ResidenzWebsite = 'residenzWebsite',
		 Resolved = 'resolved',
		 SelectedImage = 'selectedImage',
		 SelectIssueTopic = 'selectIssueTopic',
		 Send = 'send',
		 SetCultureConfirmationMessage = 'setCultureConfirmationMessage',
		 SetCultureErrorMessage = 'setCultureErrorMessage',
		 SetPassword = 'setPassword',
		 SetPasswordMessage = 'setPasswordMessage',
		 SetPasswordWelcomeMessage = 'setPasswordWelcomeMessage',
		 ShowAllAnnouncements = 'showAllAnnouncements',
		 Sink = 'sink',
		 SomethingWentWrong = 'somethingWentWrong',
		 Status = 'status',
		 Submit = 'submit',
		 Success = 'success',
		 Title = 'title',
		 Toilet = 'toilet',
		 ToiletSeatBroken = 'toiletSeatBroken',
		 ToiletSeatCoverBroken = 'toiletSeatCoverBroken',
		 ToiletSeatCoverMissing = 'toiletSeatCoverMissing',
		 ToiletSeatMissing = 'toiletSeatMissing',
		 UnsupportedPhotoExtensionMessage = 'unsupportedPhotoExtensionMessage',
		 User = 'user',
		 Walls = 'walls',
		 WaterKeepsRunningAfterFlushing = 'waterKeepsRunningAfterFlushing',
		 WhatIsAbout = 'whatIsAbout',
		 Window = 'window',
		 WrongEmailOrPassword = 'wrongEmailOrPassword',
		 Year = 'year',
		 Yes = 'yes',
		 YouAreReportingAProblemConcerningThe = 'youAreReportingAProblemConcerningThe',
		 YouAreReportingProblemInThe = 'youAreReportingProblemInThe',
		 YouAreReportingProblemInYourUnitAt = 'youAreReportingProblemInYourUnitAt',
		 RecordVideoHeader = 'recordVideoHeader',
		 Record = 'record',
		 StopRecording = 'stopRecording',
		 TakeAPhoto = 'takeAPhoto',
		 UploadFile = 'uploadFile',
		 Uploading = 'uploading',
		 UseCamera = 'useCamera',
		 VideoClipPreviewHeader = 'videoClipPreviewHeader',
		 VideoProcessingInfo = 'videoProcessingInfo',
		 ConfirmDeleteVideo = 'confirmDeleteVideo',
		 FileOverSizeLimit = 'fileOverSizeLimit',
		 MaximumUploadFileSize = 'maximumUploadFileSize',
		 Or = 'or',
		 OK = 'oK',
		 UpdateAvailable = 'updateAvailable',
		 UpdateAvailableMessage = 'updateAvailableMessage',
		 Offline = 'offline',
		 OfflineMessage = 'offlineMessage',
		 Reload = 'reload',
		 Lang_hu = 'lang_hu',
		 AnnouncementsDescription = 'announcementsDescription',
		 Communications = 'communications',
		 DocumentsDescription = 'documentsDescription',
		 IssueStatusDescription = 'issueStatusDescription',
		 Element = 'element',
		 Finish = 'finish',
		 Type = 'type',
		 BuildingDescription = 'buildingDescription',
		 DwellingDescription = 'dwellingDescription',
		 ExternalDescription = 'externalDescription',
		 EmergencyContacts = 'emergencyContacts',
		 Home = 'home',
		 MessageCentre = 'messageCentre',
		 MyAccount = 'myAccount',
		 InYourUnit = 'inYourUnit',
		 InTheBuilding = 'inTheBuilding',
		 ExternalPremises = 'externalPremises',
		 DirectContactManagement = 'directContactManagement',
		 Reference = 'reference',
		 ContactInformationEmergenciesLabel = 'contactInformationEmergenciesLabel',
		 AdditionalDetails = 'additionalDetails',
		 SpecificLocation = 'specificLocation',
		 TypeOfProblem = 'typeOfProblem',
		 Contacts = 'contacts',
		 AddedBy = 'addedBy',
		 AddedOn = 'addedOn',
		 NoAnnouncements = 'noAnnouncements',
		 NoNotifications = 'noNotifications',
		 ContactInformation = 'contactInformation',
		 Zendesk = 'zendesk',
		 EnterCurrentPassword = 'enterCurrentPassword',
		 Next = 'next',
		 EnterNewPassword = 'enterNewPassword',
		 PasswordInCorrect = 'passwordInCorrect',
		 AnnouncementsInfo = 'announcementsInfo',
		 DocumentsInfo = 'documentsInfo',
		 NoDocuments = 'noDocuments',
		 ChangePassword = 'changePassword',
		 PasswordChangedSuccess = 'passwordChangedSuccess',
		 PasswordDoesNotMatch = 'passwordDoesNotMatch',
		 ProblemStatus = 'problemStatus',
		 NoProblems = 'noProblems',
		 NoEmergencyContactsDescription = 'noEmergencyContactsDescription',
		 NoEmergencyContacts = 'noEmergencyContacts',
		 NoContactsDescription = 'noContactsDescription',
		 NoContacts = 'noContacts',
		 NoAnnouncementsDescription = 'noAnnouncementsDescription',
		 NoDocumentsDescription = 'noDocumentsDescription',
		 NoProblemsDescription = 'noProblemsDescription',
		 CreateIssueNotificationNoMediaWarning = 'createIssueNotificationNoMediaWarning',
		 DummyLabelNoSpecificArea = 'dummyLabelNoSpecificArea',
		 DummyLabelKitchen = 'dummyLabelKitchen',
		 DummyLabelLivingRoom = 'dummyLabelLivingRoom',
		 DummyIssueTitle = 'dummyIssueTitle',
		 DummyIssueMessage = 'dummyIssueMessage',
		 DummyIssueDetails = 'dummyIssueDetails',
		 DummyIssueLocation = 'dummyIssueLocation',
		 DummyIssueType = 'dummyIssueType',
	}


